import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/npsbg.png'


const _hoisted_1 = { id: "AxxessSurveyModal" }
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = {
  class: "main-table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "primary-title mb-4" }, "HELP US HELP YOU", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "content-paragraph" }, " Axxess is a trusted partner in your success. Your feedback ensures we meet your needs and deliver solutions that make it easier to do what you love. ", -1 /* HOISTED */)
const _hoisted_6 = {
  width: "100%",
  border: "0",
  cellpadding: "0"
}
const _hoisted_7 = {
  style: {"background-color":"#4d85ff","width":"220px","height":"40px","margin-right":"10px","margin-left":"30px"},
  border: "0"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","font-family":"helvetica, arial, sans-serif"} }, [
  /*#__PURE__*/_createElementVNode("a", { style: {"text-decoration":"none","color":"#ffffff"} }, "TAKE SURVEY")
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  style: {"background-color":"#b9243c","width":"220px","height":"40px","border":"1px solid white"},
  border: "0"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","font-family":"helvetica, arial, sans-serif"} }, [
  /*#__PURE__*/_createElementVNode("a", { style: {"text-decoration":"none","color":"#ffffff"} }, "REMIND ME LATER")
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "267",
  height: "386",
  style: {"position":"relative"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("div", null, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("table", _hoisted_7, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                style: {"text-align":"center","cursor":"pointer"},
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ok()))
                              }, _hoisted_9)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("table", _hoisted_10, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                style: {"text-align":"center","cursor":"pointer"},
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remindMeLater()))
                              }, _hoisted_12)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_13
          ])
        ])
      ])
    ])
  ]))
}